module.exports = {
  QuickEntry: 'Lối tắt',
  LastRefreshTime: 'Ngày cập nhật',
  SopBoard: 'Bảng điều khiển SOP',
  SeaExport: 'XK biển',
  SeaImport: 'NK biển',
  AirExport: 'XK hàng không',
  AirImport: 'NK hàng không',
  RailwayExport: 'XK đường sắt',
  RailwayImport: 'NK đường sắt',
  IntegratedJob: 'Logistics tổng',
  BusinessVolumeGraph: 'Biểu đồ khối lượng nghiệp vụ',
  PackUp: 'Thu gọn',
  Unfold: 'Mở rộng',
  SopReveal: 'Hiển thị SOP',
  SopFilterConditions: 'Điều kiện lọc SOP',
  SaveSucceed: 'Lưu thành công',
  QuickEntryPopover: {
    FirstLine: '1. Bạn có thể kéo thả chức năng bất kỳ từ thanh menu vào lối tắt',
    SecondLine: '2. Khi có quá nhiều lối tắt không hiển thị hết trên một dòng, hệ thống sẽ tự động xuống dòng.'
  },
  SopBoardPopover: {
    FirstLine: '1. Bảng SOP chỉ thống kê nghiệp vụ bạn có quyền xem và chỉ hiển thị các nút/trạng thái bạn đã chọn.',
    SecondLine: '2. Khi trạng thái nghiệp vụ chuyển sang "Hoàn thành" sẽ không xuất hiện trong nút này nữa.',
    ThirdLine: '3. Di chuột lên nút sẽ hiển thị trạng thái bạn đã chọn và số lượng nghiệp vụ tương ứng.',
    FourthLine: '4. Nhấp vào nút hoặc trạng thái đều có thể chuyển đến chức năng nghiệp vụ tương ứng để tra cứu.'
  },
  LineChartPopover: {
    FirstLine: '1. Biểu đồ khối lượng chỉ hiển thị số nghiệp vụ mới liên quan đến bạn trong 7 ngày gần nhất.'
  },
  SopFilterContent: {
    SopFilterConditionsTip: 'Nghiệp vụ thỏa mãn bất kỳ điều kiện nào sau đây sẽ được thống kê trên bảng SOP',
    BusinessState: 'Theo trạng thái nghiệp vụ',
    Operation: 'Đang xử lý',
    Submit: 'Đã gửi',
    Audit: 'Đã duyệt',
    Date: 'Theo ngày nghiệp vụ',
    ETD: 'Ngày nghiệp vụ (ETD) không sớm hơn',
    ETA: 'Ngày nghiệp vụ (ETA) không sớm hơn',
    Days: 'ngày trước',
    PleaseInputDays: 'Vui lòng nhập số ngày',
    PleaseSelectBusinessType: 'Vui lòng chọn ít nhất một trạng thái nghiệp vụ',
    PreCommit: 'Chuẩn bị gửi'
  },
  QuickEntryLayer: {
    FirstLine: '1. Nhấp vào đây để nhanh chóng truy cập chức năng',
    SecondLine: '2. Có thể kéo trực tiếp từ menu để tạo lối tắt'
  },
  SopBoardLayer: {
    FirstLine: '1. Khu vực này hiển thị các nút SOP bạn quan tâm',
    SecondLine: '2. Di chuột lên nút sẽ hiển thị số lượng nghiệp vụ theo từng trạng thái',
    ThirdLine: '3. Các nút và trạng thái hiển thị đều có thể tùy chỉnh',
    FirstLine2: '1. Khu vực này hiển thị các hạng mục bảng tin bạn quan tâm',
    SecondLine2: '2. Nhấp vào hạng mục tương ứng sẽ hiển thị dữ liệu liên quan'
  },
  LineChartLayer: {
    FirstLine: '1. Khu vực này hiển thị số nghiệp vụ mới liên quan đến bạn trong 7 ngày gần nhất',
    SecondLine: '2. Có thể thống kê riêng theo ngày nghiệp vụ và ngày tạo nghiệp vụ'
  },
  SettingLayer: {
    FirstLine: 'Nhấp vào nút bánh răng để vào trang cấu hình điều chỉnh nút/trạng thái hiển thị trên bảng SOP',
    SecondLine: 'Hiển thị thời gian cập nhật dữ liệu gần nhất'
  },
  NextStep: 'Bước tiếp theo',
  Loading: 'Đang tải dữ liệu...',
  hasPermission: 'Xin lỗi, bạn không có quyền truy cập',
  warningMessage: 'Cảnh báo',
  ignoreMessage: 'Bỏ qua tin nhắn',
  ignoreSelected: 'Bỏ qua lựa chọn',
  restoreSelected: 'Khôi phục lựa chọn',
  ScreeningContent: 'Lọc nội dung:',
  Warning: 'Cảnh báo',
  nodeName: 'Tên nút',
  nodeState: 'Trạng thái nút',
  warningLevel: 'Cấp độ cảnh báo',
  warningAt: 'Thời gian cảnh báo',
  warningContent: 'Nội dung cảnh báo',
  sift: 'Lọc',
  toDoList: 'Danh sách việc cần làm',
  SopWarning: 'Cảnh báo SOP',
  DelTrackingDetailConfirm: 'Lưu ý: Sẽ xóa các chi tiết nghiệp vụ và nút SOP liên quan',
  DelTrackingConfirm: 'Bạn có muốn xóa nút này không? Sau khi xóa, các nút liên quan trên chứng từ nghiệp vụ cũng sẽ bị xóa đồng bộ.',
  copyTrackingTemplateConfirm: 'Bạn có muốn sao chép mẫu 【{0}】 không?',
  SelectTheNode: 'Chọn nút',
  StatusType: 'Loại trạng thái',
  AutomaticTriggering: 'Tự động kích hoạt',
  ExternalEncoding: 'Mã bên ngoài',
  ReportTemplate: 'Mẫu báo cáo',
  SendNotifications: 'Gửi thông báo',
  NotSendNotifications: 'Không gửi thông báo',
  InitialState: 'Trạng thái ban đầu'
}
